import { Translation } from './types';

export const ja: Translation = {
  common: {
    loading: '読み込み中...',
    error: 'エラー',
    cancel: 'キャンセル',
    save: '保存',
    close: '閉じる',
    search: '検索',
    reload: '再読み込み',
    logout: 'ログアウト',
    dashboard: 'ダッシュボード',
    products: '商品',
    settings: '設定',
    language: '言語',
    businessHours: '営業時間',
    back: '戻る',
    selectAll: 'すべて選択',
    deselectAll: '選択解除',
    success: '成功',
    selected: '選択済み',
    confirm: '確認',
    required: '必須',
    requiredMarker: '※',
    previous: '前へ',
    next: '次へ',
    allRightsReserved: 'All rights reserved.',
  },
  auth: {
    login: 'ログイン',
    email: 'メールアドレス',
    password: 'パスワード',
    loginButton: 'ログイン',
    loggingIn: 'ログイン中...',
    loginSuccess: 'ログイン成功',
    loginError: 'メールアドレスまたはパスワードが正しくありません',
    invalidEmail: '有効なメールアドレスを入力してください',
    requiredFields: 'メールアドレスとパスワードを入力してください',
    demoAccount: 'デモ用アカウント:',
    loginDescription: 'アカウント情報を入力してログインしてください',
    welcomeMessage: 'ビジネス発注システムへようこそ',
    // Registration
    register: '新規登録',
    createAccount: 'アカウント作成',
    confirmPassword: 'パスワード確認',
    passwordRequirements: 'パスワードは8文字以上で、大文字・小文字・数字・特殊文字を含む必要があります',
    passwordsDoNotMatch: 'パスワードが一致しません',
    registrationSuccess: '登録が完了しました',
    registrationDescription: 'ビジネスアカウントの新規登録',
    alreadyHaveAccount: 'すでにアカウントをお持ちですか？',
    signIn: 'ログイン',
    dontHaveAccount: 'アカウントをお持ちでないですか？',
    creatingAccount: 'アカウント作成中...',
    registrationNote: '注意:',
    registrationNotePoints: {
      erpLinking: '既存のビジネスアカウントがある場合、メールアドレスが自動的にリンクされます',
      companyEmail: '登録には会社のメールアドレスをご使用ください',
      contactSupport: '登録にサポートが必要な場合は、お問い合わせください'
    },
    b2bUsers: 'ビジネスアカウントユーザー:',
    registeredEmail: '登録したメールアドレス',
    registeredPassword: '登録時に設定したパスワード',
    b2bCustomerRequired: 'このメールアドレスはビジネス顧客として登録されていません。まず営業担当にお問い合わせいただき、ビジネス関係を確立してください。',
    b2bVerificationError: 'ビジネス顧客ステータスを確認できませんでした。サポートにお問い合わせください。',
    // Password Reset
    passwordReset: 'パスワードリセット',
    passwordResetDescription: 'メールアドレスを入力して一時パスワードを取得してください',
    getTemporaryPassword: '一時パスワードを取得',
    processing: '処理中...',
    passwordResetComplete: 'パスワードリセット完了',
    temporaryPasswordGenerated: '一時パスワードが生成されました',
    temporaryPassword: '一時パスワード',
    backToLogin: 'ログインに戻る',
    securityNotice: 'セキュリティ通知:',
    securityNotePoints: {
      keepSecret: '一時パスワードを他の人と共有しないでください',
      changeAfterLogin: 'ログイン後は必ずパスワードを変更してください',
      expires24Hours: '一時パスワードは24時間後に期限切れになります'
    },
    resetNote: '注意:',
    resetNotePoints: {
      registeredEmail: '登録されたメールアドレスを入力してください',
      passwordDisplayed: '一時パスワードは画面に表示されます',
      changeRequired: 'ログイン後にパスワード変更が必要です'
    },
    copied: 'コピー完了',
    copySuccessMessage: '一時パスワードがクリップボードにコピーされました。',
    forgotPassword: 'パスワードを忘れましたか？',
    // Password Reset Email Request
    sendResetLink: 'リセットリンクを送信',
    sendingEmail: 'メール送信中...',
    emailSent: 'メール送信完了',
    emailSentMessage: 'このメールアドレスがシステムに存在する場合、間もなくパスワードリセットリンクが送信されます。',
    emailNotSent: 'メールが送信されませんでした',
    emailSentInfo: 'メール受信箱とスパムフォルダを確認してください',
    checkEmail: 'メールを確認',
    emailInstructions: 'パスワードリセットの指示が送信されました',
    nextSteps: '次のステップ:',
    nextStepsList: {
      checkInbox: 'メール受信箱とスパムフォルダを確認してください',
      clickLink: 'メール内のリセットリンクをクリックしてください',
      linkExpires: 'リンクは24時間で期限切れになります',
      contactSupport: 'メールが届かない場合はサポートにお問い合わせください',
      rateLimitInfo: '1時間に3回まで制限されています'
    },
    // Password Reset Completion
    resetLinkSent: 'リセットリンク送信完了',
    resetSuccess: 'パスワードリセット成功',
    passwordUpdated: 'パスワード更新完了',
    passwordUpdateMessage: 'パスワードが正常に更新されました。新しいパスワードでログインできます。',
    loginWithNewPassword: '新しいパスワードでログイン',
    // Reset Token Page
    resetToken: 'パスワードリセット',
    invalidToken: '無効なリセットトークン',
    expiredToken: 'リセットトークンの期限が切れています',
    tokenValid: 'リセットトークンは有効です',
    newPassword: '新しいパスワード',
    confirmNewPassword: '新しいパスワードの確認',
    updatePassword: 'パスワードを更新',
    updatingPassword: 'パスワード更新中...',
    passwordMismatch: 'パスワードが一致しません',
    resetInstructions: '新しいパスワードを入力してリセットを完了してください',
  },
  accountInfo: {
    title: 'アカウント情報',
    loading: 'アカウント情報を読み込み中...',
    error: 'エラー',
    errorMessage: 'アカウント情報の取得に失敗しました',
    back: '戻る',
    basicInfo: '基本情報',
    name: '氏名',
    email: 'メールアドレス',
    contactId: 'Knitido顧客ID',
    contactNumber: '連絡先番号',
    noInfo: '情報なし',
    companyInfo: '会社情報',
    company: '会社名',
    position: '役職',
    vatId: 'VAT ID',
    billingAddress: '請求先住所',
    deliveryAddress: '配送先住所',
    addressInfo: '住所情報',
    billingDescription: '請求書や契約書類の宛先住所',
    deliveryDescription: '商品配送の標準住所',
    sameAsBilling: '※ 請求先住所と同じ',
    sameAsDelivery: '※ 配送先住所と同じ',
    companyName: '会社名',
    contactPerson: '担当者',
    address: '住所',
    phoneNumber: '電話番号',
    billingUsage: '請求書、契約書、その他重要書類の宛先として使用されます',
    deliveryUsage: '注文商品の標準配送先として使用されます',
    alsoUsedForDelivery: '配送先としても使用されます',
    accountType: 'アカウントタイプ',
    addressId: '住所ID',
    // Address editing functionality
    edit: '編集',
    editDeliveryAddress: '配送先住所を編集',
    editDeliveryDescription: '配送先住所情報を更新してください',
    newDeliveryAddress: '新しい配送先住所を追加',
    newDeliveryDescription: '新しい配送先住所の詳細を入力してください',
    noDeliveryAddress: '配送先住所が設定されていません',
    success: '成功',
    addressUpdated: '配送先住所を正常に更新しました',
    updateError: '配送先住所の更新に失敗しました',
    requiredFields: '必須項目をすべて入力してください',
    firstName: '名',
    lastName: '姓',
    streetAddress: '住所',
    streetAddress2: '住所2',
    city: '市区町村',
    country: '国',
    selectCountry: '国を選択...',
    searchCountry: '国を検索...',
    noCountryFound: '国が見つかりません',
    postalCode: '郵便番号',
    companyNamePlaceholder: '会社名を入力',
    firstNamePlaceholder: '名',
    lastNamePlaceholder: '姓',
    streetAddressPlaceholder: '住所を入力',
    streetAddress2Placeholder: 'アパート、スイートなど',
    cityPlaceholder: '市区町村を入力',
    postalCodePlaceholder: '郵便番号を入力',
    billingNotEditable: '請求先住所は編集できません。',
    billingContactSupport: '変更についてはサポートにお問い合わせください。',
    // Multiple delivery addresses
    deliveryAddressCount: '{count}件の配送先住所',
    noDeliveryAddresses: '配送先住所が登録されていません',
    defaultAddress: 'デフォルト',
    selectDeliveryAddress: '配送先住所を選択',
    addNewAddress: '新しい住所を追加',
    editAddress: '住所を編集',
    deleteAddress: '住所を削除',
    confirmDelete: '削除の確認',
    confirmDeleteMessage: 'この住所を削除してもよろしいですか？この操作は取り消せません。',
    addressAddedSuccess: '配送先住所を追加しました',
    addressDeletedSuccess: '配送先住所を削除しました',
    deleteError: '配送先住所の削除に失敗しました',
    saving: '保存中...',
    cancel: 'キャンセル',
    saveChanges: '変更を保存',
    selectedDeliveryAddress: '選択中の配送先住所',
  },
  dashboard: {
    title: 'ビジネスパートナー',
    subtitle: '商品注文システム',
    welcome: 'ようこそ、',
    welcomeMessage: 'ビジネスパートナー注文システムへようこそ。こちらで商品をご注文いただけます。',
    productCatalog: '商品カタログ',
    productCatalogDesc: '利用可能な商品を閲覧・注文',
    viewProducts: '商品を見る',
    orderHistory: '注文履歴',
    orderHistoryDesc: '過去の注文を確認（準備中）',
    accountSettings: 'アカウント設定',
    accountSettingsDesc: 'アカウント情報を管理（準備中）',
    comingSoon: '準備中',
    infoTitle: '使い方について',
    orderingInfo: '商品注文',
    orderingDesc: 'カタログから商品を選択し、サイズと色を指定してください。在庫情報はリアルタイムで表示されます。',
    supportInfo: 'サポート',
    supportDesc: 'ご質問がございましたらお気軽にお問い合わせください。',
    viewOrderHistory: '注文履歴を表示',
    viewOrders: '注文を表示',
    accountInfo: 'アカウント情報',
    accountInfoDesc: 'アカウント詳細を確認',
    viewDetails: '詳細を表示',
    supportEmail: 'b2b-partner@knitido.de',
    supportPhone: '+49(0)30 6640 9300',
    businessHours: '月〜金 9:00 AM - 3:00 PM CET',
    bulkImportDesc: 'Excel/CSVファイルから注文をインポート',
    importOrders: '注文をインポート',
  },
  products: {
    title: '商品一覧',
    subtitle: 'ビジネスパートナー',
    searchPlaceholder: '商品名またはSKUで検索...',
    productId: '商品ID',
    addToCart: 'カートに追加',
    selectVariation: 'バリエーションを選択',
    price: '価格',
    priceNetNotice: 'すべての価格は税抜き価格です',
    stock: '在庫',
    color: '色',
    newProducts: '新商品',
    newProductBadge: '新商品',
    size: 'サイズ',
    quantity: '数量',
    total: '合計',
    cart: 'カート',
    checkout: 'チェックアウト',
    csvMode: 'CSV高速モード',
    csvInfo: 'CSVデータから取得した商品データ',
    csvUploadDate: 'CSVアップロード日：',
    stockNote: '※ 在庫情報は商品バリエーション選択時に取得されます',
    noProducts: '商品が見つかりません',
    noProductsDesc: '検索条件を変更するか、高速化のためにCSVファイルをアップロードしてください。',
    retry: '再試行',
    pagination: 'アイテム',
    variations: 'バリエーション',
    stockFetchError: '在庫取得エラー',
    stockFetchFailed: '在庫取得失敗',
    stockFetchFailedDesc: '在庫情報を取得できませんでした。CSV在庫が表示されます。',
    stockFetched: '在庫情報を取得しました',
    totalStock: '総在庫',
    noStockAll: 'すべてのバリエーションの在庫がゼロです',
    noStockData: '在庫データが返されませんでした',
    stockFetchErrorDesc: '在庫情報の取得中にエラーが発生しました',
    selectionError: '選択エラー',
    enterQuantity: '数量を入力してください',
    addedToCart: 'カートに追加されました',
    typesAdded: ' 商品タイプが追加されました',
    addToCartError: 'カートへの追加エラー',
    addToCartErrorDesc: 'もう一度お試しください',
    loadingStock: '在庫情報を読み込み中',
    csvDataInfo: 'CSVデータ情報を表示（実際の在庫レベルではありません）',
    invalidDataFormat: '商品データ形式が無効です',
    loadFailed: '商品データの読み込みに失敗しました',
    csvUploadComplete: 'CSVアップロード完了',
    csvLoadedDesc: ' 商品データが読み込まれました。在庫情報は商品選択時に取得されます。',
    searchTitle: '商品検索',
    loadingProducts: '商品データを読み込み中',
    noProductsCsv: 'CSVデータに商品が見つかりません。検索条件を変更してください。',
    paginationDisplay: ' 表示中',
    previous: '前へ',
    next: '次へ',
    selectionSummary: '選択サマリー',
    selectedQuantity: '選択数量',
    items: ' アイテム',
    viewDetails: '詳細を表示',
    productImage: '商品画像',
    correspondingVariations: '対応するバリエーション',
    clickToEnlarge: 'クリックして拡大',
    productIdLabel: '商品ID',
    colorLabel: '色',
    filterByCategory: 'カテゴリで絞り込む',
    allProducts: 'すべての商品',
    applyFilters: 'フィルターを適用',
    clearFilters: 'フィルターをクリア',
    filters: 'フィルター',
    clearAll: 'すべてクリア',
  },
  categories: {
    category_21: 'つま先ソックス',
    category_23: '未分類',
    category_24: 'ボディウェア',
    category_29: 'B2B商品',
  },
  productDetail: {
    title: '商品詳細',
    backToProducts: '商品一覧に戻る',
    productNotFound: '商品が見つかりません',
    productNotFoundDesc: '指定された商品は存在しないか削除されています。',
    loading: '商品を読み込み中...',
    imageLoadError: '画像の読み込みに失敗しました',
    noImages: '利用可能な画像がありません',
    productDescription: '商品説明',
    colors: '色',
    sizes: 'サイズ',
    colorCount: '色',
    sizeCount: 'サイズ',
    variationCount: 'バリエーション',
    selectVariation: 'バリエーションを選択',
    descriptionLanguageNote: '※ 商品説明は英語またはドイツ語でのみ利用可能です',
  },
  colors: {
    schwarz: '黒',
    weiß: '白',
    grau: 'グレー',
    rot: '赤',
    blau: '青',
    grün: '緑',
    gelb: '黄',
    rosa: 'ピンク',
    lila: '紫',
    braun: '茶',
    orange: 'オレンジ',
    beige: 'ベージュ',
    navy: 'ネイビー',
    dunkelblau: 'ダークブルー',
    hellblau: 'ライトブルー',
    dunkelgrau: 'ダークグレー',
    hellgrau: 'ライトグレー',
    bordeaux: 'ボルドー',
    türkis: 'ターコイズ',
    khaki: 'カーキ',
    mint: 'ミント',
    violett: 'バイオレット',
    anthrazit: 'アンスラサイト',
    blaugrau: 'ブルーグレー',
    burgunderrot: 'バーガンディ',
    elfenbein: 'アイボリー',
    karminrot: 'カーマイン',
    neongrün: 'ネオングリーン',
    gelbgrün: 'イエローグリーン',
    pistazie: 'ピスタチオ',
    // 英語色名（Product ID 237などで使用）
    blue: 'ブルー',
    ivory: 'アイボリー',
    green: 'グリーン',
    gold: 'ゴールド',
    red: 'レッド',
  },
  checkout: {
    title: 'チェックアウト',
    cartReview: '注文確認',
    orderSummary: '注文概要',
    shippingInfo: '配送情報',
    billingInfo: '請求情報',
    orderNotes: '注文メモ',
    orderNotesPlaceholder: '特別なリクエストやメモ...',
    contactPerson: '担当者',
    phoneNumber: '電話番号',
    email: 'メールアドレス',
    company: '会社',
    address: '住所',
    city: '市区町村',
    postalCode: '郵便番号',
    country: '国',
    deliveryDate: '配送日',
    urgentDelivery: '緊急配送（3-5営業日）',
    standardDelivery: '標準配送（7-10営業日）',
    placeOrder: '注文する',
    backToCart: '商品選択に戻る',
    requiredField: '必須項目',
    orderTotal: '注文合計',
    subtotal: '小計',
    priceNetNotice: 'すべての価格は税抜き価格です',
    stockReservationNotice: '在庫の予約は注文確認後に行われます。',
    stockCheckError: '在庫確認エラー',
    stockCheckErrorDesc: '在庫確認中にエラーが発生しました。再試行してください。',
    shipping: '配送',
    shippingCost: '配送料',
    tax: '税',
    orderSuccess: '注文成功',
    orderSuccessMessage: '注文が正常に送信されました。注文番号: {orderNumber}',
    orderNumber: '注文番号',
    thankYou: 'ご注文ありがとうございます！',
    orderConfirmation: 'ご注文が正常に送信されました。',
    orderProcessing: 'チームによる確認後、メールで注文確認書をお送りします。',
    orderProcessingMessage: 'ご注文が正常に送信されました。チームによる確認後、メールで注文確認書をお送りします。',
    continueShopping: 'ショッピングを続ける',
    emptyCart: 'カートが空です',
    emptyCartMessage: '商品をカートに追加してください',
    stockWarning: '在庫警告',
    stockWarningDesc: '一部のアイテムの在庫が不足しています。数量を調整してください。',
    stockError: '在庫エラー',
    stockErrorDesc: '在庫が不足しているアイテムがあります。数量を調整してください。',
    refreshStock: '在庫を更新',
    stockUpdated: '在庫更新完了',
    stockUpdatedDesc: '在庫が更新されました - {changed} アイテムが変更されました',
    stockCheckDesc: '在庫との比較結果が表示されます',
    stockOk: '在庫OK',
    stockShortage: '在庫不足',
    requestedQty: 'リクエスト数量',
    currentStock: '現在の在庫',
    stockShortageMsg: '在庫が不足しています。数量を調整してください。',
    stockIssueWarning: '在庫の問題により注文を確認できません。',
    stockDataMissing: '在庫データを取得中です。少々お待ちください。',
    outOfStock: '在庫切れ。',
    maxAvailable: '最大',
    maxQuantityReached: '最大在庫数量に達しました。',
    autoRestored: 'カートを復元しました',
    autoRestoredDesc: '前回のセッションから商品を復元しました',
    // ERP Contact Search
    contactSearch: '顧客連絡先検索',
    contactSearchDesc: '注文者のメールアドレスを入力して連絡先情報を取得してください',
    emailAddress: 'メールアドレス',
    searchButton: '検索',
    searching: '検索中',
    contactFound: '連絡先が見つかりました',
    contactNotFound: '連絡先が見つかりません',
    contactId: 'Knitido顧客ID',
    companyName: '会社',
    contactPersonLabel: '担当者',
    addressesFound: '住所が見つかりました',
    addressType: 'タイプ',
    addressBilling: '請求先住所',
    addressDelivery: '配送先住所',
    vatSourceCompany: '企業情報',
    vatSourceBilling: '請求先',
    vatSourceDelivery: '配送先',
    addressOther: 'その他',
    addressDetails: '住所',
    loadingAddresses: '住所情報を読み込み中...',
    addressRetrieved: '住所情報を取得しました',
    addressNotFound: '住所情報が見つかりません',
    addressNotFoundDesc: '住所情報が登録されていません。手動で入力してください。',
    addressError: '住所取得エラー',
    addressErrorDesc: '住所情報の取得に失敗しました。',
    contactNotConfirmed: '顧客連絡先が確認されていません',
    contactNotConfirmedDesc: 'メールアドレスを入力して連絡先を検索してください。',
    searchContact: '連絡先を検索',
    inputError: '入力エラー',
    inputErrorDesc: '配送情報が不完全です。確認してください。',
    processing: '処理中...',
    erpContactSearch: '顧客連絡先検索',
    contactSearchError: 'メールアドレスが登録された連絡先と一致しません。',
    // Product Images Toggle
    showProductImages: '商品画像を表示',
    showProductImagesDesc: 'より良い概要のために商品画像を表示（読み込み時間が増加する場合があります）',
    // System Registration Info
    systemRegistrationInfo: 'お客様情報',
    editShippingAddress: '配送先住所を編集',
    systemRegistrationInfoDesc: '登録されたビジネス情報です。請求先住所の詳細を更新する必要がある場合は、担当者にお問い合わせください。',
    // Order Summary
    regularPrice: '通常卸売価格',
    offeredPrice: '提供価格',
    discount: '割引',
    b2bCustomer: 'B2B顧客',
    pattern: 'パターン',
    specialPriceApplied: '特別価格が適用されています',
    customerClassification: '顧客分類',
    paymentCondition: '支払条件',
    invoice: '請求書払い (NET 30)',
    prepayment: '先払い',
    paymentMethod: '支払い方法',
    invoicePayment: '請求書払い',
    estimatedSubtotal: '見積小計',
    estimatedTotal: '見積合計',
    orderSummaryDisclaimer: 'ここに表示されている価格は見積もりです。ご注文を受け取り次第、確認を行い、最終価格、配送料、税金を含む拘束力のある注文確認書をメールでお送りします。',
    searchError: '検索エラー',
    searchErrorDesc: '連絡先検索中にエラーが発生しました。',
    confirmDeleteItem: 'アイテムを削除',
    itemDeleted: 'アイテムが削除されました',
    confirmDeleteItemDesc: '以下のアイテムをカートから削除してもよろしいですか？',
    deleteConfirm: '削除',
    contactNotes: '連絡メモ',
    contactNotesDesc: 'ご質問や特別なリクエストがございますか？お知らせください（任意）',
    contactNotesLabel: 'メッセージ',
    contactNotesPlaceholder: '例：商品に関する質問、特別な要件など',
    characters: '文字',
    contactIdLabel: 'Knitido顧客ID',
    companyLabel: '会社',
    personLabel: '担当者',
    emailLabel: 'メール',
    addressTypeLabel: 'タイプ',
    destinationLabel: '宛先',
    // Shipping Form
    shippingTitle: '配送情報',
    shippingDesc: '商品の配送先住所を入力してください',
    companyRequired: '会社 *',
    contactPersonRequired: '担当者 *',
    emailRequired: 'メールアドレス *',
    phoneRequired: '電話番号 *',
    addressRequired: '住所1 *',
    address2: '住所2（建物名/部屋番号）',
    postalCodeRequired: '郵便番号 *',
    cityRequired: '市区町村 *',
    countryRequired: '国 *',
    selectCountry: '国を選択',
    shippingMethodRequired: '配送方法 *',
    selectShippingMethod: '配送方法を選択',
    urgentDeliveryOption: '緊急配送（追加料金）',
    deliveryNotes: '配送メモ',
    deliveryNotesPlaceholder: '配送時間の希望やその他のリクエストを入力',
    standardShipping: '標準配送（3-5営業日）',
    expressShipping: '速達配送（1-2営業日）',
    overnightShipping: '翌日配送',
    germany: 'ドイツ',
    austria: 'オーストリア',
    switzerland: 'スイス',
    japan: '日本',
    shippingAddressLabel: '配送先住所',
    changeDeliveryAddress: '配送先を変更',
    selectDeliveryAddress: '配送先住所を選択',
    // Shipping Cost Details
    freeShipping: '送料無料',
    shippingError: 'エラー',
    shippingZone: '配送ゾーン',
    remainingForFreeShipping: '送料無料まであと{amount}',
    moreForFreeShipping: '送料無料',
    freeShippingProgress: '送料無料まで',
    andAboveFreeShipping: '以上で送料無料',
    freeShippingAchieved: '送料無料が適用されています',
    threshold: '以上',
    nextShippingTier: '次の送料割引',
    moreForDiscount: '追加で',
    shippingSavings: '送料が安くなります',
    orderAmountThreshold: '以上で',
    specialRegionNotice: '特別配送地域が適用されています',
    defaultShippingApplied: '標準送料が適用されています',
    requestedQuantity: '要求数量',
    availableQuantity: '利用可能数量',
    orderSubmitError: '注文送信エラー',
    orderSubmitErrorDesc: '注文の送信に失敗しました',
    upload: {
      title: 'Excel/CSV注文インポート',
      description: '注文データを含むExcelまたはCSVファイルをアップロードしてください',
      dragDropOrClick: 'ファイルをドラッグ&ドロップまたはクリックして選択',
      dropHere: 'ファイルをここにドロップ',
      supportedFormats: '対応形式：Excel（.xlsx、.xls）およびCSV（.csv）',
      maxSize: '最大ファイルサイズ：{size} MB',
      processFile: 'ファイルを処理',
      processing: 'ファイルを処理中...',
      ready: 'プレビューの準備完了',
      readyDescription: 'ファイルが正常に処理され、確認の準備ができました。',
      preview: 'プレビューを表示',
      errors: {
        fileTooLarge: 'ファイルが大きすぎます。最大サイズ：{size} MB',
        invalidFileType: '無効なファイル形式です。ExcelまたはCSVファイルをアップロードしてください',
        uploadFailed: 'ファイルのアップロードに失敗しました',
      },
    },
    // Loading messages
    loadingPage: 'ページを読み込み中...',
    loadingStock: '商品在庫を確認中...',
    loadingAccount: 'アカウント情報を読み込み中...',
    loadingError: 'エラーが発生しました...',
    loadingData: 'データを読み込み中',
    // Toast messages
    addressRetrievedTitle: '住所情報を取得しました',
    addressSetAsDelivery: ' 住所を配送先として設定しました。',
    contactFoundDesc: ' が認識されました。'
  },
  orderHistory: {
    title: '注文履歴',
    searchPlaceholder: '注文番号またはSKUで検索...',
    noOrders: '注文が見つかりません',
    noOrdersFound: '一致する注文が見つかりません',
    startShopping: '商品を見る',
    orderItems: '注文アイテム',
    viewDetails: '詳細',
    reorder: '再注文',
    orderDate: '注文日',
    orderStatus: 'ステータス',
    orderTotal: '注文合計',
    // Status translations
    statusPending: '支払い待ち',
    statusProcessing: '処理中',
    statusConfirmed: '確認済み',
    statusShipped: '発送済み',
    statusDelivered: '配送完了',
    statusCancelled: 'キャンセル',
    statusReturned: '返品',
    statusRefunded: '返金',
    statusWarranty: '保証',
    statusExchanged: '交換',
    statusRepair: '修理',
    statusUnknown: '不明',
    statusIncomplete: '未完了',
    statusWaitingPayment: '支払い待ち',
    statusInPreparation: '準備中',
    statusClearedShipping: '発送準備完了',
    statusBeingShipped: '発送中',
    statusOutgoingBooked: '出荷記録済み',
    statusReturn: '返品',
    // Additional UI elements
    itemCount: 'アイテム',
    itemCountSingular: 'アイテム',
    refreshButton: '更新',
    errorFetchingOrders: '注文履歴の取得に失敗しました',
    // Payment status features
    paymentStatus: '支払い状況',
    markAsPaid: '支払い済みにする',
    unmarkAsPaid: '支払い済みを解除',
    paidOn: '支払い日',
    paymentMarked: '支払い済み',
    notPaid: '未払い',
    paymentMarkedSuccess: '支払い済みとしてマークしました',
    paymentUnmarkedSuccess: '支払い済みマークを解除しました',
    paymentUpdateError: '支払い状態の更新に失敗しました',
    // Payment date dialog
    paymentDateTitle: '支払い情報の入力',
    paymentDateDescription: '注文番号 {orderNumber} の支払い情報を入力してください',
    paymentDateLabel: '支払い日',
    selectDate: '日付を選択',
    paymentDateHelp: '銀行振込を行った日付を選択してください',
    paymentMethodLabel: '支払い方法',
    bankTransfer: '銀行振込',
    invoice: '請求書払い',
    otherPayment: 'その他',
    paymentReferenceLabel: '振込名義・参照番号',
    paymentReferencePlaceholder: '例: 山田太郎、振込番号12345',
    paymentReferenceHelp: '銀行明細との照合に役立つ情報を入力してください',
    notesLabel: '備考',
    notesPlaceholder: '支払いに関する追加情報があれば入力してください',
    // Filter options
    filterByPaymentStatus: '支払い状況で絞り込み',
    allOrders: 'すべての注文',
    paidOrders: '支払い済み',
    unpaidOrders: '未払い',
    // Sorting options
    sortBy: '並び替え',
    sortByDate: '注文日順',
    sortByPaymentDate: '支払い日順',
    sortByAmount: '金額順',
    sortByStatus: 'ステータス順',
  },
  orderDetails: {
    title: '注文詳細',
    notFound: '注文が見つかりません',
    backToHistory: '注文履歴に戻る',
    orderDate: '注文日',
    orderItems: '注文アイテム',
    deliveryStatus: '配送ステータス',
    estimatedDelivery: '配送予定',
    deliveredOn: '配送完了日',
    downloadInvoice: '請求書をダウンロード',
    statusDelivered: '配送完了',
    statusShipped: '発送済み',
    statusConfirmed: '確認済み',
    statusCancelled: 'キャンセル',
    errorFetchingDetails: '注文詳細の取得に失敗しました',
  },
  company: {
    name: 'ビジネスパートナー',
    tagline: 'ビジネスパートナーシステム',
    copyright: '© 2025 ビジネスパートナーシステム. All rights reserved.',
  },
  footer: {
    phone: '電話',
    email: 'メール',
    countries: {
      DE: 'ドイツ',
      AT: 'オーストリア',
      CH: 'スイス',
      FR: 'フランス',
      IT: 'イタリア',
      ES: 'スペイン',
      NL: 'オランダ',
      BE: 'ベルギー',
      PL: 'ポーランド',
      SE: 'スウェーデン',
      NO: 'ノルウェー',
      FI: 'フィンランド',
      DK: 'デンマーク',
      LT: 'リトアニア',
      LV: 'ラトビア',
      EE: 'エストニア',
    },
  },
  cart: {
    newCart: '新しいカート',
    currentCart: '現在のカート',
    modified: '変更済み',
    lastSaved: '最終保存',
    unsavedChanges: '未保存の変更',
    saveCart: 'カートを保存',
    loadCart: 'カートを読み込み',
    deleteCart: 'カートを削除',
    startNewCart: '新しいカートを開始',
    savedCarts: '保存されたカート',
    cartSaved: 'カートが保存されました',
    cartDeleted: 'カートが削除されました',
    confirmDeleteCart: 'カートを削除しますか？\n\nこの操作は元に戻せません。',
    confirmSwitchCart: '現在のカートに未保存の変更があります。\n\n別のカートを読み込むと現在の変更が失われます。\n\n続行しますか？',
    confirmSwitchCartTitle: 'カートの切り替え',
    confirmNewCart: '現在のカートに未保存の変更があります。\n\n新しいカートを開始すると現在の変更が失われます。\n\n続行しますか？',
    confirmNewCartTitle: '新しいカートの開始',
    confirmClearCart: 'カートをクリアしますか？\n\n{count} アイテムが削除されます。\n\nこの操作は元に戻せません。',
    confirmClearCartTitle: 'カートをクリア',
    autoSaved: '自動保存済み',
    itemsWillBeRemoved: 'アイテムが削除されます',
    changesWillBeLost: '変更が失われます',
    continueQuestion: '続行しますか？',
    cartStatus: 'カートステータス',
    cartName: 'カート名',
    cartNamePlaceholder: '例：月末注文',
    cartNameRequired: 'カート名を入力してください',
    saveCartDescription: '現在のカートに名前を付けて保存してください。後で読み込むことができます。',
    cancelCart: 'カートをキャンセル',
    proceedToCheckout: 'チェックアウトに進む',
    emptyCart: 'カートが空です',
    erpDown: '注文システムが停止中です。時間をおいて再度お試しください',
    erpDegraded: 'ただいまシステムが不安定なため、注文に失敗する場合があります',
    erpDownSaveHint: 'カートを保存して、復旧後にご注文ください。',
    erpSaveCart: 'カートを保存',
  },
  nav: {
    dashboard: 'ダッシュボード',
    products: '商品',
    orderHistory: '注文履歴',
    account: 'アカウント情報',
    bulkImport: '一括インポート',
  },
  settings: {
    selectLanguage: '言語を選択',
    languagePreferenceSaved: '言語設定は今後の訪問時のためにアカウントに保存されます。',
  },
  reorder: {
    allItemsAdded: '{count}個の商品をカートに追加しました',
    partialSuccess: '{added}個の商品を追加しました。{failed}個の商品は追加できませんでした',
    allItemsFailed: '商品をカートに追加できませんでした',
    error: '再注文処理中にエラーが発生しました',
    itemDiscontinued: '{name} ({color}/{size}) は販売終了しました',
    itemOutOfStock: '{name} ({color}/{size}) は在庫切れです',
    partialStock: '{name} ({color}/{size}) は{available}個のみ在庫があります',
    confirmReorder: '再注文の確認',
    confirmReorderMessage: 'この注文の商品をカートに追加しますか？',
    addingToCart: 'カートに追加中...',
    checkingStock: '在庫を確認中...',
    checkoutTitle: 'カートに商品を追加しました',
    checkoutDescription: '{count}個の商品をカートに追加しました。チェックアウトに進みますか？',
  },
  bulkImport: {
    instructions: '注文のインポート方法',
    step1: '注文テンプレートファイルをダウンロード',
    step2: 'SKUと数量で注文データを記入',
    step3: 'Excel（.xlsx）またはCSVファイルとして保存',
    step4: '下記のフォームでファイルをアップロード',
    step5: '注文内容を確認して確定',
    downloadTemplate: 'テンプレートをダウンロード',
    downloadExcelTemplate: 'Excelテンプレートをダウンロード',
    downloadCsvTemplate: 'CSVテンプレートをダウンロード',
    formatGuide: 'ファイル形式ガイド',
    requiredColumns: '必須項目',
    skuDescription: '商品SKUコード',
    quantityDescription: '注文数量（正の整数）',
    optionalColumns: 'オプション項目',
    notesDescription: '社内メモ（例：発注番号、参照番号など）- お客様の記録用',
    formatNote: '最初の行には列ヘッダーを含める必要があります。データは2行目から開始します。',
    parseSuccess: 'ファイルから{count}件のアイテムを正常に読み込みました',
    parseError: '解析エラー',
    validationError: '検証エラー',
    validationErrorGuidance: '「{showPreviewButton}」ボタンをクリックして詳細を確認してください。',
    warnings: '警告',
    itemsParsed: '{count}件のアイテムを正常に読み込みました：',
    andMore: '...他{count}件のアイテム',
    validationSummary: '検証サマリー',
    duplicateSKUs: '重複したSKUが見つかりました',
    skuFormat: 'SKUは文字、数字、ハイフンのみを含む必要があります',
    quantityRange: '数量は1から9999の間である必要があります',
    maxRows: '最大1000行まで許可されています',
    rowsSkipped: '{count}行がエラーのためスキップされました',
    previewTitle: '注文プレビュー',
    previewDescription: '処理を進める前に注文データを確認・編集してください',
    proceedToCart: 'カートに追加',
    // File parsing messages
    fileEmpty: 'ファイルが空またはデータが含まれていません',
    fileTooManyRows: 'ファイルに行が多すぎます（{current}行）。最大許可数：{max}行',
    invalidRowFormat: '無効な行形式',
    missingColumns: '必須列（SKUおよび数量）が不足しています',
    missingSku: 'SKUが不足しています',
    invalidSkuFormat: '無効なSKU形式："{sku}"（パターンに一致する必要があります：{pattern}）',
    skuTooLong: 'SKUが長すぎます："{sku}"（最大50文字）',
    invalidQuantity: '無効な数量："{quantity}"は数字ではありません',
    quantityTooLow: '数量が少なすぎます：{quantity}（最小：{min}）',
    quantityTooHigh: '数量が多すぎます：{quantity}（最大：{max}）',
    notesRequired: 'メモフィールドは必須です',
    noValidData: '有効なデータが見つかりませんでした。ファイル形式を確認してください。',
    row: '行{row}：{errors}',
    rowErrors: '...他{count}件のエラー',
    duplicateSkuInRows: '重複したSKU "{sku}"が次の行で見つかりました：{rows}',
    quantityExceedsMax: '行{row}：数量{quantity}が最大許可数（{max}）を超えています',
    quantityBelowMin: '行{row}：数量{quantity}が最小必要数（{min}）を下回っています',
    // Validation messages
    unsupportedFileFormat: 'サポートされていないファイル形式です。CSVまたはExcelファイルをアップロードしてください。',
    csvParsingErrors: 'CSV解析エラーが発生しました',
    failedToParseFile: 'ファイルの解析に失敗しました',
    failedToParseExcel: 'Excelファイルの解析に失敗しました',
    failedToReadFile: 'ファイルの読み取りに失敗しました',
    unknownError: '不明なエラーが発生しました',
    totalRows: '総行数',
    valid: '有効',
    invalid: '無効',
    skipped: 'スキップ',
    // SKU validation
    skuValidationError: 'SKU検証エラー',
    skuValidationFailed: 'SKUの検証に失敗しました。続行できますが、一部のアイテムが利用できない可能性があります。',
    skuNotFound: 'SKUがデータベースに見つかりません',
    skusNotFound: '{count}件のSKUがデータベースに見つかりません',
    itemsHaveInsufficientStock: '{count}件の商品の在庫が不足しています',
    validatingSKUs: '商品を確認中...',
    // Table headers
    actions: 'アクション',
    notes: 'メモ',
    // Status filter
    all: 'すべて',
    hasErrors: 'エラーあり',
    // Selection summary
    selected: '選択済み',
    errors: 'エラー',
    // Pagination
    page: 'ページ {current} / {total}',
    previous: '前へ',
    next: '次へ',
    noResults: '結果がありません。',
    // Cart integration
    noValidItems: '有効なアイテムがありません',
    allItemsHaveErrors: 'すべてのアイテムに検証エラーがあります。続行する前に修正してください。',
    dataLoadingError: 'データ読み込みエラー',
    failedToLoadProductData: '商品データの読み込みに失敗しました。もう一度お試しください。',
    itemsAddedToCart: '{count}個のアイテムがカートに追加されました',
    itemsAddedMessage: '{count}個のアイテムをカートに追加しました',
    someSkusNotFound: '{count}件のSKUが見つかりませんでした。',
    noItemsAdded: 'アイテムが追加されませんでした',
    couldNotFindProducts: 'SKUに一致する商品が見つかりませんでした。',
    errorAddingToCart: 'エラー',
    failedToAddToCart: 'カートへの追加に失敗しました。もう一度お試しください。',
    addingToCart: 'カートに追加中...',
    // File info
    fileSelected: '処理のために{name}が選択されました',
    fileSize: '{size}バイト',
    fileSizeKB: '{size} KB',
    fileSizeMB: '{size} MB',
    // Template download
    templateDownload: 'テンプレートダウンロード',
    templateWillBeImplemented: 'テンプレートダウンロードはフェーズ7で実装予定です',
    // Additional validation
    validationFailed: '検証に失敗しました',
    // Template download
    templateDownloaded: 'テンプレートをダウンロードしました',
    templateDownloadError: 'テンプレートのダウンロードに失敗しました',
    // Template content
    sheetName: '一括注文',
    instructionsSheetName: '説明',
    columnDescriptions: '列の説明：',
    columnHeader: '列名',
    columnRequired: '必須',
    columnOptional: '任意',
    columnDescription: '説明',
    templateNotes: '注意事項：',
    templateNote1: '1行目には表示されている通りの列ヘッダーを含める必要があります',
    templateNote2: 'データは2行目から開始します',
    templateNote3: 'SKUはシステムに登録されている商品コードと一致する必要があります',
    templateNote4: '数量は1から9999の間の正の整数である必要があります',
    templateNote5: 'ファイルあたり最大1000行まで',
    templateNote6: '.xlsxまたは.csv形式で保存してください',
    stockAvailabilityWarning: '実際の在庫有無の確認は次のチェックアウトページで行われます。',
    outOfStock: '在庫切れ',
    insufficientStock: '在庫不足: {available}個在庫、{requested}個要求',
    unvalidatedChanges: '未検証の変更があります。カートに追加する前に再検証してください。',
    revalidate: '再検証',
    validating: '検証中...',
    validationSuccess: 'すべてのアイテムが有効です',
    validationComplete: '検証完了',
    validationResultSummary: 'エラー{errors}件、警告{warnings}件が見つかりました',
  },
  orderExport: {
    export: '注文をエクスポート',
    exportOrder: '注文データをエクスポート',
    exportAsCSV: 'CSV形式でエクスポート',
    exportAsExcel: 'Excel形式でエクスポート',
    exportForReorder: '一括インポート用にエクスポート',
    detailed: '詳細情報',
    simpleFormat: 'インポート形式',
  },
};